import { typographyDefinition } from "@huub-web/ui/theme/typography";
import { responsiveCard } from "@huub-web/ui/utils/responsive";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const containerStyle = style({});

export const contentStyle = style({});

export const titleStyle = recipe({
  base: {
    fontWeight: "bold",
    ...responsiveCard({
      500: {
        ...typographyDefinition.displayS,
        fontWeight: "bold",
      },
    }),
  },
});
